import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

import { ITableColumnConfig } from '@ib-shared/interfaces/table-column-config.intf copy';

@Component({
  selector: 'ib-table-cell-content',
  templateUrl: './table-cell-content.component.html',
  styleUrls: ['./table-cell-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellContentComponent {
  @Input() column: ITableColumnConfig;
  @Input() row: Record<string, string | number>;
  @Input() isMobileView: boolean;

  @HostBinding('class') get classes(): string {
    return this.column.forceAlignment
      ? 'text-' + this.column.forceAlignment
      : 'ib-table-cell-content--' + this.column.dataType;
  }

  constructor(public bpS: UiBreakpointsService) {}
}

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiBreakpointsService } from '@ib-core/services/ui-breakpoints.service';

import { DataViewModule } from '../data-view/data-view.module';

@NgModule({
  declarations: [TableCellContentComponent],
  imports: [CommonModule, DataViewModule],
  exports: [TableCellContentComponent],
})
export class TableCellContentModule {}
